module.exports = __webpack_public_path__ + "img/20210430_110537.1f2814c8.jpg";